import { Controller } from "@hotwired/stimulus"

// Кастомная обёртка над нативным <input type="file"> — сам input визуально
// скрыт (.kit-file-input__native), но остаётся в DOM и доступен с клавиатуры;
// клик открывается через <label for="..."> без JS. Контроллер только
// подставляет имя выбранного файла в текст лейбла.
export default class extends Controller {
  static targets = ["input", "label"]

  updateLabel() {
    const file = this.inputTarget.files[0]
    this.labelTarget.textContent = file ? file.name : this.labelTarget.dataset.placeholder
  }
}
